import { createSelector } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { PhaseEntityType } from 'components/organisms/projects/project-plan/phase-entity';
import { RootState } from 'data';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { SprintIdPayload, deleteSprintInProjectTemplate } from '../../actions';
import { selectTemplateSprint } from '../../selectors';
import {
  deleteProjectTemplateSprint,
  setProjectTemplateActiveRecord,
} from '../../slices';
import {
  ProjectTemplateActiveRecord,
  ProjectTemplateSprint,
} from '../../types';

const selectActiveRecord = createSelector(
  (state: RootState) => state.templates.project.activeRecord,
  (
    activeRecord: ProjectTemplateActiveRecord | undefined,
  ): ProjectTemplateActiveRecord | undefined => activeRecord,
);

function* deleteSprintInTemplateSaga(
  action: StoreActionProps<SprintIdPayload>,
) {
  try {
    const {
      payload: { sprintId },
    } = action;

    const sprint: ProjectTemplateSprint = yield select(
      selectTemplateSprint(sprintId),
    );
    const activeRecord = yield select(selectActiveRecord);

    const shouldChangeActiveRecord =
      activeRecord && activeRecord.type === PhaseEntityType.Sprint
        ? sprint.sprintId === activeRecord.id
        : false;

    if (sprint.projectPhase) {
      yield put(deleteProjectTemplateSprint({ sprintId }));

      if (shouldChangeActiveRecord) {
        yield put(
          setProjectTemplateActiveRecord({
            id: sprint.projectPhase.projectPhaseId,
            type: 'PROJECT_PHASE',
          }),
        );
      }
    }
  } catch (error) {
    logger.error('deleteSprintInTemplateSaga failed ', { error });

    message.error('There was an error deleting the sprint');
  }
}

export function* watchDeleteSprintInProjectTemplateSaga(): Generator {
  yield takeLatest(
    deleteSprintInProjectTemplate.type,
    deleteSprintInTemplateSaga,
  );
}
